/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */
import axios from 'axios';
import { PaymentMethod } from '@/store/slices/order';
import { Taxes } from '@/components/Invoices/InvoiceItem';

export interface PrinterKOTType {
  port: string;
  ipAddress: string;
  invoice: string;
  kotID: string;
  customer: string;
  items: any[];
  area: string;
  table: string;
  waiter: string;
  reprinted: boolean;
  createdAt: string;
}

interface PrinterBillType {
  port: string;
  ipAddress: string;
  customer: string;
  items: any[];
  taxes: Taxes[];
  waiter: string;
  restaurant: string;
  netTotal: string;
  /** Grand total (e.g. POS grand_total: after discount, including tax). */
  total: string;
  discount: number;
  currency: string;
  businessAccountName?: string | undefined;
  businessAccountNumber?: string | undefined;
  businessBankName?: string | undefined;
  enableDetailsOnBill?: number;
}

interface PrinterInvoiceType {
  showBusinessInfo?: boolean;
  businessInfo?: Record<string, string>;
  port: string;
  ipAddress: string;
  customer: string;
  items: any[];
  taxes: Taxes[];
  cashier: string;
  restaurant: string;
  netTotal: string;
  subTotal: string;
  currency: string;
  invoice: string;
  taxId: string;
  message: string;
  change: number;
  changeGiven: number;
  changeSaved: number;
  paymentMethod: Array<PaymentMethod>;
  discount: string;
}

export const printKOT = (data: PrinterKOTType) => {
  axios.post(' http://localhost:3001/print/kot', {
    data: {
      port: data.port,
      ipAddress: data.ipAddress,
      invoice: data.invoice,
      id: data.kotID,
      customer: data.customer,
      waiter: data.waiter,
      table: data.table,
      area: data.area,
      items: data.items,
      reprinted: data.reprinted,
      createdAt: data.createdAt,
    },
  });
};

export const printBill = (data: PrinterBillType) => {
  axios.post(' http://localhost:3001/print/bill', {
    data: {
      restaurant: data.restaurant,
      port: data.port,
      ipAddress: data.ipAddress,
      customer: data.customer,
      waiter: data.waiter,
      items: data.items,
      netTotal: data.netTotal,
      total: data.total,
      discount: data.discount,
      taxes: data.taxes,
      currency: data.currency,
      businessAccountName: data?.businessAccountName ?? '',
      businessAccountNumber: data?.businessAccountNumber ?? '',
      businessBankName: data?.businessBankName ?? '',
      enableDetailsOnBill: data?.enableDetailsOnBill ?? 0,
    },
  });
};

export const printInvoice = (data: PrinterInvoiceType) => {
  axios.post(' http://localhost:3001/print/invoice', {
    data: {
      showBussinessInfo: data.showBusinessInfo,
      businessInfo: data.businessInfo,
      taxId: data.taxId,
      restaurant: data.restaurant,
      port: data.port,
      ipAddress: data.ipAddress,
      customer: data.customer,
      cashier: data.cashier,
      items: data.items,
      netTotal: data.netTotal,
      subTotal: data.subTotal,
      taxes: data.taxes,
      currency: data.currency,
      invoice: data.invoice,
      message: data.message,
      change: data.change,
      changeGiven: data.changeGiven,
      changeSaved: data.changeSaved,
      paymentMethod: data.paymentMethod,
      discount: data.discount,
    },
  });
};

export const sortAndMergePrinter = (data: PrinterKOTType[]) => {
  const mergedItems: Record<string, PrinterKOTType> = {};

  data.forEach((item) => {
    const key = item.area; // JSON.stringify({ ...item, items: undefined }); // Ignore the 'items' property when forming the key
    if (!mergedItems[key]) {
      mergedItems[key] = { ...item, items: [] };
    }
    mergedItems[key].items.push(item.items);
  });

  const mergedItemsArray = Object.values(mergedItems);

  return mergedItemsArray;
};
